export function normaliseEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function normaliseContactTelephone(contact: string): string {
  // lower and remove all white space
  return contact.replace(/\s/g, '').toLowerCase();
}
